import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class SortTableService {
  public sortingFiled: string;
  public sortingPar: boolean;
  public sorted: any[];
  public sortedSensorList: any[];

  public ascName: boolean = true;

  public ascLoc: boolean = true;
  public ascOrg: boolean = true;
  public ascProj: boolean = true;
  public ascStatus: boolean = true;
  public ascDate: boolean = true;

  public descName: boolean = true;
  public descLoc: boolean = true;
  public descProj: boolean = true;
  public descOrg: boolean = true;
  public descStatus: boolean = true;
  public descDate: boolean = true;

  /**
   * Sort table columns
   * @param sort
   * @param asc
   * @param dataList
   */
  public sortData(sort: string, asc: boolean, dataList) {
    this.sortingFiled = sort;
    this.sortingPar = asc;
    let data = [...dataList];
    this.sortedSensorList = data.sort((a, b) => {
      let org_a = a.organizations[0] ? a.organizations[0].name : '';
      let org_b = b.organizations[0] ? b.organizations[0].name : '';
      let proj_a = a.projects[0] ? a.projects[0].name : '';
      let proj_b = b.projects[0] ? b.projects[0].name : '';

      switch (sort) {
        case 'name':
          this.ascName = false;
          this.setPositionSortingArrows(false, true, true, true, true, true);
          return this.compare(a.name, b.name);
        case 'loc':
          this.ascLoc = false;
          this.setPositionSortingArrows(true, false, true, true, true, true);
          return this.compare(a.loc, b.loc);
        case 'organization':
          this.ascOrg = false;
          this.setPositionSortingArrows(true, true, false, true, true, true);
          return this.compare(org_a, org_b);
        case 'project':
          this.ascProj = false
          this.setPositionSortingArrows(true, true, true, false, true, true);
          return this.compare(proj_a, proj_b);
        case 'status':
          this.ascStatus = false;
          this.setPositionSortingArrows(true, true, true, true, false, true);
          return this.compare(a.active, b.active);
        case 'change_date':
          this.ascDate = false;
          this.setPositionSortingArrows(true, true, true, true, true, false);
          let b_date = b.change_date ? b.change_date : b.create_ts;
          let a_date = a.change_date ? a.change_date : a.create_ts;
          return this.compare(b_date, a_date);
        default:
          return 0;
      }
    });
    this.sorted = [...this.sortedSensorList];
    if (!asc) {
      this.ascName = true;
      this.ascLoc = true;
      this.ascOrg = true;
      this.ascProj = true;
      this.ascStatus = true;
      this.ascDate = true;
      this.setPositionSortingArrows(true, true, true, true, true, true);
      this.sortedSensorList = this.sorted.reverse();
    }
  }

  /**
   * Set the position of the sorting arrow <asc down>, <desc up>
   * @param name
   * @param loc
   * @param org
   * @param proj
   * @param status
   * @param date
   */
  private setPositionSortingArrows(name: boolean, loc: boolean, org: boolean, proj: boolean, status: boolean, date: boolean) {
    this.descName = name;
    this.descLoc = loc;
    this.descOrg = org;
    this.descProj = proj;
    this.descStatus = status;
    this.descDate = date;
  }

  /**
   * Compare items for sorting table columns
   * @param a
   * @param b
   */
  public compare(a: number | string, b: number | string) {
    return a.toString().toLowerCase() == b.toString().toLowerCase() ? 0 : a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1;
  }

  /**
   * Sort data by parameter
   * @param data
   * @param parameter
   */
  sortDataByParameter(data: any, parameter: string) {
    if (data && parameter) {
      return data.sort((a, b) => (a[parameter] > b[parameter]) ? 1 : ((b[parameter] > a[parameter]) ? -1 : 0))
    }
  }

}
